import React, { useEffect, useRef, useState } from 'react';
import BackArrow from '../icons/BackArrowIcon';

interface IRightSideModal {
  isOpen: boolean;
  onClose: (data: any, isCloseButton?: boolean, isOutSide?: boolean) => void;
  children: React.ReactNode;
  data?: any;
}

const RightSideModal: React.FC<IRightSideModal> = ({
  isOpen,
  onClose,
  children,
  data,
}) => {
  const modalRef = useRef<HTMLDivElement>(null);
  // Only keep the panel's content mounted while it is open (plus the slide-out). A hidden,
  // filled address form left in the page is what makes Chrome offer to "save address" on
  // every navigation.
  const [renderContent, setRenderContent] = useState(isOpen);
  useEffect(() => {
    if (isOpen) {
      setRenderContent(true);
      return undefined;
    }
    const timer = setTimeout(() => setRenderContent(false), 300);
    return () => clearTimeout(timer);
  }, [isOpen]);

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (
        modalRef.current &&
        !modalRef.current.contains(event.target as Node)
      ) {
        onClose(data, false, true);
      }
    };
    if (isOpen) {
      document.addEventListener('mousedown', handleClickOutside);
    }
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [onClose, isOpen, data]);

  return (
    <div className={`right-side-modal ${isOpen ? 'open' : ''}`}>
      <div className="rightside-modal-content" ref={modalRef}>
        <div className="drawer-topbar">
          <button
            type="button"
            className="drawer-back"
            onClick={() => onClose(data, true)}
          >
            <BackArrow /> Back
          </button>
        </div>
        <div className="drawer-body">{renderContent ? children : null}</div>
      </div>
    </div>
  );
};

export default RightSideModal;
